<template>
	<div class="filter-sort">
		<input placeholder="search last name (all)" type="text" v-model="searchTerm" /> 
		<span>OR</span>
		<div class="all-buttons-filter">
			<button 
				v-on:click="activeSession = 'unassigned'" 
				v-bind:class="{ 'disabled': currentSession !== 'unassigned' }"
			>Unassigned</button>
			<button 
				v-for="session in sessions" 
				:key="session.id"
				v-on:click="activeSession = session.id" 
				v-bind:class="{ 'disabled': currentSession !== session.id }"
			>{{ session.label }}</button>
		</div>
	</div>
	<div class="m-list">
		<div v-for="mentee in menteesFiltered" :key="mentee.id" class="mentee" :style="menteeBgStyle(mentee)">
			<div class="m-bg">
				<SingleMentee :mentee="mentee" />
			</div>
		</div>
	</div>
</template>

<script>
import SingleMentee from './SingleMentee.vue'

export default {
	props: ['mentees'],
	components: { SingleMentee },
	data() {
		return {
			searchTerm: '',
			activeSession: null
		}
	},
	computed: {
		sessions() {
			const startYear = 2021
			const endYear = new Date().getFullYear()
			const list = []
			for (let year = startYear; year <= endYear; year++) {
				list.push({ id: `${year}-Spring`, label: `Spring ${year.toString().slice(-2)}` })
				list.push({ id: `${year}-Fall`, label: `Fall ${year.toString().slice(-2)}` })
			}
			return list
		},
		defaultSession() {
			const now = new Date()
			const season = now.getMonth() < 6 ? 'Spring' : 'Fall'
			return `${now.getFullYear()}-${season}`
		},
		currentSession() {
			return this.activeSession || this.defaultSession
		},
		menteesFiltered() {
			if (this.searchTerm !== '') {
				return this.mentees.filter(mentee => 
					mentee['name-last'].toLowerCase().match(this.searchTerm.toLowerCase())
				)
			}
			if (this.currentSession === 'unassigned') {
				return this.mentees.filter(mentee => !mentee['sessions'])
			}
			return this.mentees.filter(mentee => 
				mentee['sessions'] === this.currentSession
			)
		}
	},
	methods: {
		menteeBgStyle(mentee) {
			if (mentee.headshots && mentee.headshots[0]) {
				return `background-image:url(https://ucarecdn.com/${mentee.headshots[0]}/-/stretch/fill/-/resize/210x/-/quality/lightest/-/blur/66); background-size: cover; background-position: center center`
			}
			return false
		}
	}
}
</script>